import React from 'react';

import DialogContent from 'components/DialogContent';
import { H2 } from 'components/Heading';
import { ModalFooterButton } from 'components/Modal';
import { BlueskySocialCircle } from 'components/SocialCircle';
import { Step } from 'components/SteppedModal';
import { block } from '../../utils';
import { BlueskyPostModalSteps } from '../types';

interface UseAuthorizationStepConfig {
  isAuthenticating: boolean;
  onAuthenticate: () => void;
}

export default function useAuthorizationStep({
  isAuthenticating,
  onAuthenticate,
}: UseAuthorizationStepConfig): Step<BlueskyPostModalSteps> {
  return {
    id: 'authorization',
    fluidFooterButtons: true,
    component: (
      <DialogContent
        title="Let's add your account"
        details={
          <H2>
            We'll quickly send you to Bluesky so you can give us permission to
            add videos to your account.
          </H2>
        }
        icon={
          <BlueskySocialCircle
            className={block('icon')}
            color="#1185FE"
            width="64px"
            height="64px"
          />
        }
        detailsClassName={block('details')}
      />
    ),
    renderFooterButtons: ({ submit }) => [
      <ModalFooterButton
        {...submit}
        theme="submit"
        disabled={isAuthenticating}
        onClick={onAuthenticate}
      >
        <span>Sign in with Bluesky</span>
      </ModalFooterButton>,
    ],
  };
}
